// src/pages/Campaigns/VolunteerManagement/volunteerEnums.js

export const EventType = {
  RALLY: 'RALLY',
  DONATION: 'DONATION',
  FUNDRAISING: 'FUNDRAISING',
  COMMUNITY_SERVICE: 'COMMUNITY_SERVICE',
  OTHER: 'OTHER'
};

export const EventTypeLabels = {
  RALLY: 'Rally',
  DONATION: 'Donation',
  FUNDRAISING: 'Fundraising',
  COMMUNITY_SERVICE: 'Community Service',
  OTHER: 'Other'
};

export const PreferredTimeSlot = {
  MORNING_6_9: 'MORNING_6_9',
  AFTERNOON_1_3: 'AFTERNOON_1_3',
  EVENING_6_8: 'EVENING_6_8',
  EVENING_6_9: 'EVENING_6_9',
  FLEXIBLE: 'FLEXIBLE'
};

export const PreferredTimeSlotLabels = {
  MORNING_6_9: '6-9 AM',
  AFTERNOON_1_3: '1-3 PM (Afternoon)',
  EVENING_6_8: '6-8 PM (Evening)',
  EVENING_6_9: '6-9 PM',
  FLEXIBLE: 'Flexible'
};

export const AvailabilityType = {
  WEEKEND: 'WEEKEND',
  WEEKDAY: 'WEEKDAY',
  BOTH: 'BOTH'
};

export const AvailabilityTypeLabels = {
  WEEKEND: 'Weekend',
  WEEKDAY: 'Weekday',
  BOTH: 'Both'
};

export const VolunteerStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING'
};

export const VolunteerStatusLabels = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending'
};

export const EventStatus = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

export const EventStatusLabels = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  ONGOING: 'Ongoing',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};

export const AvailabilityStatus = {
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  CANCELLED: 'CANCELLED',
  TENTATIVE: 'TENTATIVE'
};

export const AvailabilityStatusLabels = {
  AVAILABLE: 'Available',
  NOT_AVAILABLE: 'Not Available',
  CANCELLED: 'Cancelled',
  TENTATIVE: 'Tentative'
};